var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs6":""}},[_c('h1',[_vm._v("Profile")]),(_vm.loading)?_c('CardLoader',{attrs:{"max-height":400}}):_vm._e(),_c('h2',[_vm._v("Email: "+_vm._s(_vm.email))]),_c('p',[_vm._v("AWS Token: "+_vm._s(_vm.AWSToken))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }